import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { APP_LOCALE } from "../../misc/locale";
import { englishCrmMessages } from "./englishCrmMessages";
import { spanishCrmMessages } from "./spanishCrmMessages";
import {
  spanishRaMessages,
  spanishRaSupabaseMessages,
} from "./spanishRaMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

// Almikia CRM ships in Mexican Spanish only. English stays as the fallback
// for any key missing from the Spanish catalogs.
const spanishCatalog = mergeTranslations(
  englishCatalog,
  spanishRaMessages,
  spanishRaSupabaseMessages,
  spanishCrmMessages,
);

export const i18nProvider = polyglotI18nProvider(
  () => spanishCatalog,
  APP_LOCALE,
  [{ locale: APP_LOCALE, name: "Español" }],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
